// extracted by mini-css-extract-plugin
export default {"fs":"c9204851c3 _86a3bbe543"};